<h2 mat-dialog-title>
  <ng-container *ngIf="data.name; else addBlock">
    <span
      innerHTML="Edit Item {{ data.name }} in {{ data.categoryName }}"
    ></span>
  </ng-container>
  <ng-template #addBlock>
    <span innerHTML="Add New Item to {{ data.categoryName }}"> </span>
  </ng-template>
</h2>

<mat-dialog-content>
  <form #frm="ngForm">
    <div class="section basic-section">
      <h3 class="section-title">Basic Info</h3>

      <div class="basic-fields">
        <div class="input-group">
          <label for="item-name">Item Name</label>
          <input
            id="item-name"
            name="name"
            type="text"
            [(ngModel)]="data.name"
            required
            placeholder="e.g. Cod"
          />
        </div>

        <div class="input-group">
          <label for="item-desc">Description</label>
          <textarea
            id="item-desc"
            name="description"
            rows="2"
            [(ngModel)]="data.description"
            placeholder="Short description…"
          ></textarea>
        </div>

        <div class="input-group">
          <label for="item-price">Base Price (£)</label>
          <input
            id="item-price"
            name="price"
            type="number"
            min="0"
            step="0.01"
            [(ngModel)]="data.price"
            placeholder="0.00"
          />
        </div>
      </div>
    </div>

    <div class="section groups-section">
      <h3 class="section-title">Attach Option Groups</h3>

      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Select groups</mat-label>

        <mat-select
          [(ngModel)]="selectedGroupIds"
          name="selectedGroups"
          multiple
          panelClass="waitron-select-panel"
        >
          <mat-option *ngFor="let g of availableGroups" [value]="g.optionId">
            {{ g.groupName }}
          </mat-option>
        </mat-select>

        <mat-hint
          >Choose one or more existing groups (e.g. Sauces,
          Condiments)</mat-hint
        >
      </mat-form-field>

      <div class="attached-preview" *ngIf="attachedGroups?.length">
        <h4 style="margin: 12px 0 6px">Currently attached</h4>

        <div class="attached-group" *ngFor="let g of attachedGroups">
          <div class="attached-title">
            <strong>{{ g.groupName }}</strong>
            <span class="muted" *ngIf="g.extras?.length">
              ({{ g.extras.length }} options)
            </span>
          </div>

          <ul class="attached-extras" *ngIf="g.extras?.length; else noExtras">
            <li *ngFor="let ex of g.extras">
              {{ ex.extraName }}
              <span *ngIf="ex.extraPrice"
                >(+{{
                  ex.extraPrice | currency : "GBP" : "symbol" : "1.2-2"
                }})</span
              >
            </li>
          </ul>

          <ng-template #noExtras>
            <div class="muted">No extras in this group.</div>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
